<template>
  <div style="position: relative; height: 100%; width: 100%">
    <p
      style="
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: calc(100% - 89px);
        position: absolute;
        top: 8px !important;
        font-weight: bold;
        color: #000;
      "
    >
      {{ this.title }}
    </p>
    <div
      v-if="data !== null && data.length > 0"
      :id="id"
      style="height: 100%; width: 100%"
    ></div>
    <div v-else class="display">
      <div class="main">
        <!-- <span class="title">{{ title }}</span> -->
        <img
          src="../../../assets/images/fta/targetContrastSearch/display.png"
        />
        <span class="tip"
          >The index data of the selected FTZ has not been published<br />Please
          select another FTZ</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  props: {
    id: {
      type: String,
      default: "main",
    },
    title: {
      type: String,
      default: "",
    },
    zb: {
      type: Array,
      default() {
        return [];
      },
    },
    zmq: {
      type: Array,
      default() {
        return [];
      },
    },
    year: {
      type: Array,
      default() {
        return [];
      },
    },
    data: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      // 进出口总额
      jckze: {
        // 当前 图表 柱状图 和 折线图 切换
        // true => 柱状图  false => 折线图
        check: true,
        option1: [],
        option2: [],
      },
      jckze_option_zhe: "",
      // 新增企业
      xzqy: {
        check: true,
        option1: [],
        option2: [],
      },
      // 新增外资
      xzwz: {
        check: true,
        option1: [],
        option2: [],
      },
      // 纳税总额
      ns: {
        check: true,
        option1: [],
        option2: [],
      },
    };
  },
  computed: {
    jckze_option_zhe_set: function () {
      let series_data = [];
      this.zmq.forEach((i) => {
        let item = {};
        item.name = i;
        item.type = "line";
        item.stack = "Total";
        item.data = [];
        this.data.forEach((j) => {
          if (j.title === i) {
            item.data.push(j.total);
          }
        });
        series_data.push(item);
      });
      return {
        // title: {
        //   text: this.title,
        //   top: 8,
        //   textStyle: {
        //     // with: '',
        //     fontSize: 12
        //   },
        // },
        tooltip: {
          show: true,
          extraCssText: "width:auto !important;height:auto !important;",
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        color: ["#92B4F9", "#F8CD57", "#977AFD", "#FA9857","#7EDE75"],
        legend: {
          data: this.zmq,
          bottom: 30,
        },
        grid: {
          left: 50,
          bottom: 120,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.year,
        },
        yAxis: {
          type: "value",
        },
        series: series_data,
        dataZoom: [
          {
            type: "slider",
            start: 0,
            end: 50,
            height: 17,
            bottom: 10,
          },
        ],
      };
    },
  },
  watch: {
    data: {
      handler() {
        this.init();
      },
      deep: true,
    },
  },
  methods: {
    init() {
      if (this.data !== null && this.data.length > 0) {
        if (this.jckze_option_zhe !== "") {
          this.jckze_option_zhe.dispose();
        }
        this.$nextTick(() => {
          this.jckze_option_zhe = echarts.init(
            document.getElementById(this.id)
          );
          this.jckze_option_zhe.setOption(this.jckze_option_zhe_set);
          console.log("触发resize()11111");
          this.jckze_option_zhe.resize();
        });
      }
    },
    resizeLine() {
      this.jckze_option1_zhu.resize();
    },
  },
  created() {},
  mounted() {
    console.log("qqqqqqq");
    this.init();
  },
};
</script>

<style lang="less" scoped>
.echarts {
  z-index: 90;
  position: absolute !important;
  width: calc(100% - 30px);
  height: calc(100% - 25px);
  background-color: lemonchiffon;
}
.echarts > div {
  width: 100% !important;
  height: 100% !important;
}
.bottom {
  padding: 20px;
  width: 100%;
  height: 450px;
  // border: 1px solid #ddd;
  // background-color: goldenrod;
  display: flex;
  flex-direction: row;
  .item {
    padding-top: 15px;
    padding-bottom: 10px;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 3px;
    position: relative;
    margin-left: 10px;
    margin-right: 10px;
    height: 100%;
    flex-grow: 1;
    border-radius: 4px;
    background-color: rosybrown;
    // border: 1px solid #ddd;
    // background-color: #fbfbfb;
    .check {
      z-index: 100;
      right: 10px;
      top: 10px;
      position: absolute;
      width: 75px;
      height: 35px;
      // background-color: rebeccapurple;
      display: flex;
      justify-content: space-between;
      img {
        cursor: pointer;
        width: 35px;
        height: 35px;
      }
    }
  }
}
.display {
  height: 100%;
  width: 100%;
  position: relative;
  padding-top: 8px;
  .main {
    text-align: left;
    width: 100%;
    height: 100%;
    // background-color: green;
    // border: 1px solid #ddd;
    position: relative;
    .title {
      margin: 0;
      padding: 0;
      font-size: 13px;
      color: rgba(0, 0, 0, 0.86);
      font-weight: bold;
    }
    img {
      height: 105px;
      width: 134px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .tip {
      width: 100%;
      font-size: 17px;
      text-align: center;
      position: absolute;
      bottom: 65px;
      left: 0;
    }
  }
}
</style>